var upsellSwiper = new Swiper(".upsell-slider", {
    slidesPerView: "auto",
    spaceBetween: 15,
    grabCursor: !0
  }),
  swiperContainer = document.querySelector(".upsell-slider"),
  swiperWrapper = swiperContainer.querySelector(".swiper-wrapper"),
  slides = swiperWrapper.querySelectorAll(".swiper-slide"),
  totalWidth = 0,
  gapWidth = 15;
slides.forEach(function(e) {
  totalWidth += e.clientWidth + gapWidth
});
var maxTranslation = 0,
  minTranslation = -(totalWidth - swiperContainer.clientWidth),
  activeSlideIndex = 0,
  nextButton = document.querySelector(".card-slider__navigation__button--next");
nextButton.addEventListener("click", function() {
  moveToNextSlide()
});
var prevButton = document.querySelector(".card-slider__navigation__button--prev");

function moveToNextSlide() {
  activeSlideIndex < slides.length - 1 && (slides[activeSlideIndex].classList.remove("upsell-active"), slides[++activeSlideIndex].classList.add("upsell-active"), updateSliderPosition(), swiperWrapper.style.transitionDuration = "300ms", setTimeout(() => {
    swiperWrapper.style.transitionDuration = "0ms"
  }, 300)), updateButtonVisibility(), displayFilters()
}

function moveToPrevSlide() {
  activeSlideIndex > 0 && (slides[activeSlideIndex].classList.remove("upsell-active"), slides[--activeSlideIndex].classList.add("upsell-active"), updateSliderPosition(), swiperWrapper.style.transitionDuration = "300ms", setTimeout(() => {
    swiperWrapper.style.transitionDuration = "0ms"
  }, 300)), updateButtonVisibility(), displayFilters()
}

function updateSliderPosition() {
  var e = slides[activeSlideIndex].clientWidth + gapWidth,
    t = -(activeSlideIndex * e) + 1 * e;
  t = Math.max(minTranslation, Math.min(maxTranslation, t)), swiperWrapper.style.transform = "translate3d(" + t + "px, 0, 0)"
}

function updateButtonVisibility() {
  0 === activeSlideIndex || 1 === activeSlideIndex ? prevButton.classList.add("hideButton") : prevButton.classList.remove("hideButton"), activeSlideIndex >= slides.length - 3 ? nextButton.classList.add("hideButton") : nextButton.classList.remove("hideButton")
}

function displayFilters() {
  let e = document.querySelectorAll(".swiper-slide"),
    t = document.querySelectorAll(".upsell-filters");
  t.forEach(e => {
    e.classList.remove("active")
  }), e.forEach(e => {
    if (e.classList.contains("upsell-active")) {
      let t = e.getAttribute("data-upsell-id"),
        i = document.getElementById(t);
      i && i.classList.add("active")
    }
  })
}
prevButton.addEventListener("click", function() {
  moveToPrevSlide()
}), prevButton.classList.add("hideButton"), upsellSwiper.on("slideChange", function() {
  upsellSwiper.isBeginning ? prevButton.classList.add("hideButton") : prevButton.classList.remove("hideButton"), upsellSwiper.isEnd ? nextButton.classList.add("hideButton") : nextButton.classList.remove("hideButton")
}), displayFilters();